// extracted by mini-css-extract-plugin
export default {"menuItem":"dnrZSGKxfobDYqbWNbtZ","endIcon":"MDLdu2ttK3JrS7mR2FVH"};